//#region Componentes
import { Column, ParagraphSection } from "components/styles";
//#endregion
//#region Images
import actionImage from "img/action_image.svg";
//#endregion

const EmptyData = ({
    content
}) => {
    return (
        <Column 
            width="100%" 
            align="center" 
            marginTop="90px" gap="30px">
            <img src={actionImage}/>
            <ParagraphSection>
                {content}
            </ParagraphSection>
        </Column>
    );
}

export default EmptyData;